/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconArrowUp/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconArrowUp({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconArrowUp",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconArrowUp.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-Z1dc2gj': alignSelf,'--mt-2-Z1dc2gj': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1dc2gj': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1dc2gj': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1dc2gj': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1dc2gj': opacity,'--w-10-Z1dc2gj': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1dc2gj': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1dc2gj': fill,'--a-7-Z1dc2gj': isAnimated ? animation : "none",'--sd-8-Z1dc2gj': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1dc2gj': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconArrowUp.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M15.707 12.207a1 1 0 000-1.414l-5.646-5.647a1.5 1.5 0 00-2.122 0l-5.646 5.647a1 1 0 001.414 1.414L9 6.914l5.293 5.293a1 1 0 001.414 0z"
 style={{'--f-12-Z1dc2gj': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}